<div *ngIf="type !== 'countries' && type !== 'sectors' && type !== 'ods' && type !== 'multiEvents'">
  <!--<img class="pointer" width="24" [hidden]="!items['checked'] || isFather" height="24" [alt]="'checked'" src="assets/img/checkbox_checked.svg">
  <img class="pointer" width="24" [hidden]="items['checked'] || isFather" height="24" [alt]="'unchecked'" src="assets/img/checkbox_unchecked.svg">
  <div class="item"><span *ngIf="isFather">{{ index + 1 }}.</span> {{utilsService._api(items['translations'], 'name')}}</div>
  <img class="pointer" width="24" [hidden]="!items['opened'] || !isFather" height="24" [alt]="'arrowUp'" src="assets/img/keyboard_arrow_up.svg">
  <img class="pointer" width="24" [hidden]="items['opened'] || !isFather" height="24" [alt]="'arrowDown'" src="assets/img/keyboard_arrow_down.svg">
  -->
</div>
<div [hidden]="items[childsPropertyName]?.length < 1" class="properties-container" *ngIf="type !== 'countries' && type !== 'sectors'">
  <div *ngFor="let item of items[childsPropertyName]; index as i; trackBy: utilsService.trackByItems" [hidden]="!items['opened']">
    <app-filter-items [type]="type" [items]="item" [index]="i"></app-filter-items>
  </div>
</div>

<div class="search-bar-container" *ngIf="type === 'multiEvents' && index < 1">
  <div class="search_bar">
    <input class="search_input" [(ngModel)]="searchText" [placeholder]="'FILTER_ITEMS.SEARCH' | translate">
    <img class="pointer" width="24" height="24" [alt]="'search_for'" src="assets/img/search.svg">
  </div>
</div>


<!-- countries & sectors -->
<div class="item-container" [ngClass]="{ 'item-container--is-father': isFather }" (click)="toggleItem(items, isFather)" *ngIf="!isArray && (type === 'countries' || type === 'sectors' || type === 'multiEvents')">
  <img class="pointer" width="24" [hidden]="!items['checked'] || isFather" height="24" [alt]="'checked'" src="assets/img/checkbox_checked.svg">
  <img class="pointer" width="24" [hidden]="items['checked'] || isFather" height="24" [alt]="'unchecked'" src="assets/img/checkbox_unchecked.svg">
  <div class="item" [hidden]="type !== 'countries'">{{utilsService._api(items['translations'], 'translation')}}</div>
  <div class="item" [hidden]="type !== 'sectors'">{{utilsService._api(items['translations'], 'name')}}</div>
  <div class="item" [hidden]="type !== 'multiEvents'">{{ items['label'] }}</div>
</div>

<div class="properties-container" *ngIf="isArray && (type === 'countries' || type === 'sectors' || type === 'multiEvents')">
  <div *ngFor="let item of items; trackBy: utilsService.trackByItems">
    {{type}}
    <app-filter-items [type]="type" [items]="item"></app-filter-items>
  </div>
</div>

<!-- ODS -->
<div class="item-container" [ngClass]="{ 'item-container--is-father': isFather }" (click)="toggleItem(items, isFather)" *ngIf="type === 'ods' && !isFather && items['id']">
  <img class="pointer" [ngClass]="{ 'ods-active-img': items['checked'] }" width="90" height="90" [alt]="utilsService._api(items['translations'], 'name')" src="{{ 'assets/img/ods/' + translateService.currentLang  + '/ODS_' + items['id'] + '.png' }}">
</div>

<div class="properties-container properties-container--ods" *ngIf="isArray && type === 'ods'">
  <div *ngFor="let item of items; trackBy: utilsService.trackByItems">
    <app-filter-items [type]="type" [items]="item"></app-filter-items>
  </div>
</div>
